<template>
    <div>

        <div class="modal fade" id="planningProductionEventBoxModal" tabindex="-1" aria-labelledby="planningProductionEventBoxModal" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="px-4 py-2">
                        <div class="modal-icon text-center mt-2">
                            <span class="round-icon bg-lightyellow">
                                <i class="fa fa-bell text-primary" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="modal-body">
                            <h3 class="mb-2 text-primary text-center">Gegevens productie</h3>
                            <table style="width: 100%;">
                                <tr>
                                    <td style="width: 35%;" class="strong">Montage/levering</td>
                                    <td style="width: 65%;" class="strong">{{ this.item.title }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Zaagnummer</td>
                                    <td>{{ this.item.saw_nr ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gesorteerd</td>
                                    <td>{{ this.item.arranged ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gezaagd</td>
                                    <td>{{ this.item.sawn ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gefreesd</td>
                                    <td>{{ this.item.milled ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Gelast</td>
                                    <td>{{ this.item.welded ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Geschroefd</td>
                                    <td>{{ this.item.screwed ?? '-' }}</td>
                                </tr>
                                <tr>
                                    <td class="strong">Geladen</td>
                                    <td>{{ this.item.loaded ?? '-' }}</td>
                                </tr>
                            </table>

                            <div class="modal-body pt-4 px-4 pb-4 d-flex">
                                <a :href="this.item.order_url" class="btn btn-primary ms-auto px-3 py-2 text-sm">
                                    Bekijk opdracht
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    import {EventBus} from "../../../event-bus";

    export default {
        name: 'planning-production-modal',
        components: {},
        props: {},
        data() {
            return {
                item: {
                    saw_nr: '',
                    arranged: '',
                    sawn: '',
                    milled: '',
                    welded: '',
                    screwed: '',
                    loaded: '',
                    order_url: '',
                    date: '',
                }
            }
        },
        computed: {},
        watch: {},
        methods: {},
        mounted() {

            this.planningProductionEventBoxModal = new bootstrap.Modal(document.getElementById('planningProductionEventBoxModal'));

            EventBus.$on('showPlanningProductionEvent', (item) => {
                this.item = item;
                this.planningProductionEventBoxModal.show();
            });
        },
        created() {},
    }
</script>

<style scoped>
    td {
        vertical-align: top;
    }
</style>
